import React from 'react';
import ReactSelect from 'react-select';

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '48px',
    borderRadius: '0.5rem',
    borderColor: state.isFocused ? '#2563EB' : '#9CA3AF',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(37, 99, 235, 0.1)' : 'none',
    backgroundColor: '#fff',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSize: '1rem',
    transition: 'all 0.2s',
    '&:hover': {
      borderColor: state.isFocused ? '#2563EB' : '#9CA3AF',
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: '#9CA3AF',
    fontWeight: 400,
  }),
  singleValue: (base) => ({
    ...base,
    color: '#1F2937',
    fontWeight: 400,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#2563EB'
      : state.isFocused
        ? '#EFF6FF'
        : '#fff',
    color: state.isSelected ? '#fff' : '#1F2937',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSize: '1rem',
    padding: '10px 16px',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: '#DBEAFE',
    },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '0.5rem',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
    border: '1px solid #E5E7EB',
    overflow: 'hidden',
    zIndex: 50,
  }),
  menuList: (base) => ({
    ...base,
    padding: '4px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? '#2563EB' : '#9CA3AF',
    '&:hover': { color: '#2563EB' },
  }),
};

const Select = ({
  label,
  id,
  error,
  className = '',
  ...props
}) => {
  return (
    <div className={`tw-flex tw-flex-col tw-gap-1.5 ${className}`}>
      {label && (
        <label
          htmlFor={id}
          className="tw-text-sm tw-font-medium tw-text-gray-700"
        >
          {label}
        </label>
      )}
      <ReactSelect
        inputId={id}
        styles={customStyles}
        {...props}
      />
      {error && (
        <p className="tw-text-xs tw-text-error tw-mt-0">{error}</p>
      )}
    </div>
  );
};

export default Select;
export { customStyles };
